import React from 'react';
import { firstPageWrapper, tableWrapper, tableStyle } from './styles';
import { InspectionRow, PageHeader, TableHeader } from './components';

export const InspectionsExport = ({ startDate, endDate, inspections, status, searchTerms, properties, groups, selectedPropertyIds, selectedGroupIds }) => {

  let firstPage = (
    <div style={firstPageWrapper}>
      <PageHeader
        startDate={startDate}
        endDate={endDate}
        status={status}
        searchTerms={searchTerms}
        properties={properties}
        groups={groups}
        selectedPropertyIds={selectedPropertyIds}
        selectedGroupIds={selectedGroupIds}
      />
      <div style={tableWrapper}>
        <table style={tableStyle}>
          <TableHeader status={status} />
          {inspections.map(inspection => (<InspectionRow inspection={inspection} status={status} />))}
        </table>
      </div>
    </div >
  );

  return firstPage;
}

